import React from 'react';
import useProjectDetails from '../../hooks/useProjectDetails';

export default function withProjectDetails(Component: any): React.FC<any> {
	return function WithProjectDetails(props): JSX.Element {
		const projectDetails = useProjectDetails('always');

		return <Component {...projectDetails} {...props} />;
	};
}

